import { useQuery } from "@tanstack/react-query";

import { Banner } from "../types/banners.types";
import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { getServiceBanners } from "../services/goHireService";

export const useServiceBanners = () => {
  return useQuery<Banner[]>({
    queryKey: GO_SERVICE_QUERY_KEYS.serviceBanners(),
    queryFn: getServiceBanners,
  });
};
